module.exports = __webpack_public_path__ + "img/tu1.a3e1061f.png";